import React from "react";

import Randomizador from "./Randomizador";
import {useTranslation} from "react-i18next";

const ConfigNft = () => {
  const [ t ] = useTranslation(['home']);
  return (
    <div className="" id="randomizador">
      <div className="container  ">
        <div className="row pt-5">
          <div className="col-12 col-lg-6 mt-5">
            <label className="colordisabled l-SyncopateBold">
              {t('Collection')} MR CRYPTO
            </label>
            <h1 className="section-title rleft">{t('DiscoverThemAll')}</h1>
            <p>
              {t('UseOur')} <span>{t('NftCreator')}</span>  {t('messageCreatornft')}  <span>{t('Settings')}</span> {t('thatTheyCanGetMrCrypto')}
            </p>
          </div>
        </div>
        <Randomizador />
      </div>
    </div>
  );
};

export default ConfigNft;
